import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "256",
  height: "256",
  fill: "currentColor",
  viewBox: "0 0 200 200"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-width": "18",
      d: "M30 150q30-50 70-20t70-20q4-30-16-40-16 0-16 16 0 14-16 14-12-4-12-20"
    }, null, -1),
    _createElementVNode("path", { d: "m60 118 10-10 10 10zM90 130l10-12 10 12zM120 148l10-10 10 10zM150 120l10-12 8 12z" }, null, -1),
    _createElementVNode("circle", {
      cx: "154",
      cy: "70",
      r: "3",
      fill: "var(--mc-avatar)"
    }, null, -1)
  ]))]))
}
export default { render: render }